import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import queryDuck from '@/features/storeBonusesPage/ducks/query';
import withQuerySync from '@/hocs/withQuerySync';

import {
  getStoreBonusesError,
  getStoreBonusesTotalCount,
  getStoreBonusIds,
  isLoadingStoreBonuses,
} from '../selectors';
import StoreBonuses from './component';
import styles from './styles';

const mapStateToProps = state => ({
  error: getStoreBonusesError(state),
  storeBonusIds: getStoreBonusIds(state),
  isLoading: isLoadingStoreBonuses(state),
  totalCount: getStoreBonusesTotalCount(state),
});

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
  withStyles(styles),
)(StoreBonuses);
